/**
 * Canonical demo user IDs from seed (TestDB).
 * Phase 5.2: RFC 4122 UUID v5 values from `phase5SeedIdMap.manifest.json` (see `apps/api/src/domain/phase5SeedIdMap.ts`).
 * Legacy string IDs for migrations live in `PHASE5_LEGACY_DEMO_USER_IDS` in that module.
 */

export const DEMO_USER_IDS = {
  PROPERTY_MANAGER: '08468cc8-3c8f-5346-b4a5-937becbe1e2c',
  ADMIN: '0eefbb71-92c4-56ec-846a-062cd82e4237',
  OWNER: '55ed2f3d-326f-5fd4-a44d-05f94ec99e6a',
  /** Self-managing owner demo persona (Casey Kim): `UserProfile.role` is PROPERTY_MANAGER with `isSelfManagingOwner`; linked `Owner` for Connect; same id as seed Owner row. */
  SELF_MANAGING_OWNER: '8e90f39a-46ca-574e-a191-716930b9b701',
  TENANT: 'bbdbf4c1-1188-5a19-92e3-3a05b397e7fb',
  VENDOR: '52597c6e-1d6f-51ab-b79d-26b948ccb40a',
  INVESTOR: '9b4260aa-0d82-5881-8102-e415319c1a1f',
} as const;
